import { createElementBlock as l, openBlock as t, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function n(d, e) {
  return t(), l("svg", r, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.157 2.756a.69.69 0 0 1 .974-.098L9.746 6.46a.7.7 0 0 1 0 1.08l-4.615 3.802a.69.69 0 0 1-.974-.098.7.7 0 0 1 .097-.98L8.214 7l-3.96-3.263a.7.7 0 0 1-.097-.981",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const c = { render: n };
export {
  c as default,
  n as render
};
